import DynamicFormFieldPayloadModelBase from '../_generated/modelBases/dynamic-form-field-payload-model-base';

export default class DynamicFormFieldPayloadModel extends DynamicFormFieldPayloadModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
